var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',{staticClass:"vue-slider-step",attrs:{"min":0,"max":2,"tooltip":'none',"disabled":true,"interval":1},model:{value:(_vm.stepPayment),callback:function ($$v) {_vm.stepPayment=$$v},expression:"stepPayment"}})}
var staticRenderFns = []

export { render, staticRenderFns }